// extracted by mini-css-extract-plugin
module.exports = {"form":"QuoteForm_form__1twCc","loading":"QuoteForm_loading__11pWl","control":"QuoteForm_control__15HDs","actions":"QuoteForm_actions__HPxqk"};